import React from 'react';
import { Home, RefreshCw, Bug } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ServerError = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  const handleReportIssue = () => {
    // In a real app, this would open a support ticket or email
    alert(t('errors.reportIssueAlert'));
  };

  return (
    <div className="max-w-4xl mx-auto px-6">
      <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
        <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-12 max-w-2xl">
          <div className="text-8xl font-bold text-red-600 mb-4">
            500
          </div>
          
          <h1 className="text-2xl font-bold text-gray-900 mb-4">
            {t('errors.serverError')}
          </h1>
          
          <p className="text-gray-600 mb-6 leading-relaxed">
            {t('errors.serverErrorMessage')}
          </p>
          
          <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-8 text-left">
            <div className="text-sm font-medium text-red-800 mb-2">
              {t('errors.whatYouCanDo')}
            </div>
            <ul className="text-sm text-red-700 space-y-1 ml-4 list-disc">
              <li>{t('errors.refreshPage')}</li>
              <li>{t('errors.checkConnection')}</li>
              <li>{t('errors.tryAgainLater')}</li>
              <li>{t('errors.contactSupport')}</li>
            </ul>
          </div>
          
          <div className="flex gap-4 justify-center flex-wrap">
            <button
              onClick={handleRefresh}
              className="inline-flex items-center px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors"
            >
              <RefreshCw size={20} className="mr-2" />
              {t('errors.refreshPage')}
            </button>
            
            <button
              onClick={handleGoHome}
              className="inline-flex items-center px-6 py-3 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
            >
              <Home size={20} className="mr-2" />
              {t('common.goHome')}
            </button>
            
            <button
              onClick={handleReportIssue}
              className="inline-flex items-center px-6 py-3 text-red-600 font-medium rounded-lg hover:bg-red-50 transition-colors"
            >
              <Bug size={20} className="mr-2" />
              {t('errors.reportIssue')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServerError;